<template>
    <form @submit.prevent="submit">
        <h1 class=" text-2xl font-bold">Авторизация</h1>

        <div class="mb-4 mt-6">
            <label class="block text-gray-700 text-sm font-semibold mb-2">
                Email
            </label>

            <input
                class="
                    text-sm
                    appearance-none
                    rounded
                    w-full py-2 px-3
                    text-gray-700
                    bg-gray-200
                    leading-tight
                    focus:outline-none focus:shadow-outline
                    h-10"
                :class="{'border border-red-500': isError}"
                type="email"
                placeholder="E-Mail"
                v-model="data.email" />
            
            <div class="text-red-600 text-xs mt-1" v-if="isError">Пользователь с указаными данными не найден</div>
        </div>
        <div class="mb-6 mt-6">
            <label class="block text-gray-700 text-sm font-semibold mb-2">
                Пароль
            </label>
            
            <input
                class="text-sm bg-gray-200 appearance-none rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline h-10"
                type="password"
                placeholder="Ваш пароль"
                v-model="data.password" />

        </div>
        <div class="flex w-full mt-8">
            <button class="btn btn-primary btn-wide">
                Войти
            </button>
        </div>
    </form>
</template>

<script>
    export default {
        data: () => {
            return {
                isError: false,
                data: {}
            }
        },
        methods: {
            submit () {
                this.$auth.login({
                    data: this.data,
                    rememberMe: true,
                    fetch: true,
                    redirect: {
                        name: 'profile.edit'
                    },
                    success: function () {
                        this.isError = false;
                    },
                    error: function (error) {
                        this.isError = true;
                    },
                });
            }
        }
    }
</script>